module.exports = __webpack_public_path__ + "img/img_052@2x.d8c2bd9a.png";